import React from "react";
import { Route } from "react-router-dom";
import "./App.css";

import Header from "./Components/Header/Header";
import MiniSideBar from "./Components/MiniSideBar/MiniSideBar";
import SideBar from "./Components/SideBar/Sidebar";
import Results from "./Components/Results/Results";
import Watch from "./Components/Watch/Watch";
import Home from "./Components/Home/Home";
import Aux from "./hoc/Aux";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      miniSideBar: false,
      sidebar: window.innerWidth >= 1150 ? true : false
    };
  }
  toggleMiniSidebar = () => {
    this.setState(preState => ({
      miniSideBar: !preState.miniSideBar,
      sidebar: !preState.sidebar
    }));
  };
  render() {
    return (
      <div className="App">
        <Route
          path="/"
          render={props => (
            <Header {...props} toggleMiniSidebar={this.toggleMiniSidebar} />
          )}
        />
        <Route
          path={/^\/$|^\/results$/}
          render={() => (
            <Aux>
              <SideBar extraClass={true} show={this.state.sidebar} />
              <MiniSideBar extraClass={this.state.miniSideBar} />
            </Aux>
          )}
        />
        <main>
          <Route path="/" exact component={Home} />
          <Route path="/results" component={Results} />
          <Route path="/watch" component={Watch} />
        </main>
      </div>
    );
  }
}

export default App;
